
import React from 'react';
import './ProgressBar.css';

const ProgressBarLocal = ({ progress, color = '#007bff', height = '20px' }) => {
    return (
        <div className="progress-bar-container mb-3" style={{ height }}>
            <div
                className="progress-bar-fill"
                style={{
                    width: `${progress}%`,
                    backgroundColor: color,
                }}
            />
        </div>
    );
};

export default ProgressBarLocal;
